var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Tab as HeadlesssTab } from '@headlessui/react';
import getTabSize from './private/utils/getTabSize';
import TabsContext from './private/utils/TabsContext';
import useTabsContext from './private/utils/useTabsContext';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
const TabsRoot = ({ children, selectedIndex, onChange }) => (React.createElement(HeadlesssTab.Group, { selectedIndex: selectedIndex, onChange: onChange }, children));
const List = ({ children, className, size = 'md' }) => {
    const states = {
        size: size,
    };
    return (React.createElement(TabsContext.Provider, { value: states },
        React.createElement(HeadlesssTab.List, { className: mergeClassnames('flex items-center justify-center w-fit gap-2', className) }, children)));
};
const Segment = ({ children, className, size = 'md' }) => {
    const states = {
        size: size,
    };
    return (React.createElement(TabsContext.Provider, { value: states },
        React.createElement(HeadlesssTab.List, { className: mergeClassnames('flex items-center justify-center w-fit gap-1 p-1 bg-gohan', size === 'md' ? 'rounded-moon-s-md' : 'rounded-moon-s-sm', className) }, children)));
};
const Tab = React.forwardRef((_a, ref) => {
    var { children, as = 'button', className } = _a, rest = __rest(_a, ["children", "as", "className"]);
    const { size } = useTabsContext('Tabs.Tab');
    const isDisabled = rest.disabled;
    return (React.createElement(HeadlesssTab, Object.assign({ className: ({ selected }) => mergeClassnames(getTabSize(size), 'relative flex items-center justify-center w-full whitespace-nowrap text-moon-14', 'text-bulma font-medium cursor-pointer after:absolute after:start-0 after:bottom-0', 'after:w-full after:h-[2px] after:bg-piccolo after:transition-transform', 'after:duration-300 ltr:after:origin-top-left rtl:after:origin-top-right', 'after:scale-x-0 after:scale-y-100 ltr:hover:after:origin-top-left', 'rtl:hover:after:origin-top-right hover:after:scale-100 hover:text-piccolo', 'focus:outline-none', isDisabled && 'opacity-60 hover:after:scale-0 cursor-not-allowed', selected &&
            'ltr:after:origin-top-left rtl:after:origin-top-right after:scale-x-100 text-piccolo', typeof className === 'function'
            ? className({ selected: selected })
            : className), as: as, ref: ref }, rest), children));
});
const Pill = React.forwardRef((_a, ref) => {
    var { children, className, as = 'button' } = _a, rest = __rest(_a, ["children", "className", "as"]);
    const { size } = useTabsContext('Tabs.Pill');
    const isDisabled = rest.disabled;
    return (React.createElement(HeadlesssTab, Object.assign({ className: ({ selected }) => mergeClassnames(getTabSize(size), 'flex items-center justify-center w-full whitespace-nowrap text-moon-14 text-bulma', 'font-medium rounded-moon-i-sm transition-colors cursor-pointer hover:bg-goku', 'focus:outline-none', selected && 'bg-goku', isDisabled && 'opacity-60 hover:bg-transparent cursor-not-allowed', typeof className === 'function'
            ? className({ selected: selected })
            : className), as: as, ref: ref }, rest), children));
});
const Panels = ({ children, className }) => (React.createElement(HeadlesssTab.Panels, { className: className }, children));
const Panel = ({ children, className }) => (React.createElement(HeadlesssTab.Panel, { className: className }, children));
const Tabs = Object.assign(TabsRoot, {
    Tab,
    Pill,
    List,
    Segment,
    Panels,
    Panel,
});
export default Tabs;
